import React from 'react';

import { Background, Container, Logo} from './styles/privacyHeader'; 

export default function PrivacyHeader({bg = true, children, ...restProps}){
  return bg ? <Background {...restProps}>{children}</Background> : children;
}

PrivacyHeader.Frame = function PrivacyHeaderFrame({children, ...restProps}){
    return <Container {...restProps}>{children}</Container>
}

PrivacyHeader.Logo = function PrivacyHeaderLogo({children, ...restProps}){
    return  <Logo {...restProps} />;
}